import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Loader from 'components/Loader';
import Button from 'components/CustomButtons/Button.jsx';
import Store from 'services/StoreService';
import { updateUserData } from 'store/actions/userActions';
import fyndaGenres from 'config/fyndaGenres';

const PickGenres = ({ uid, location, favoriteGenres, updateUserData }) => {
  const { nextPage } = location;

  const toggleFavorite = async (genre, isFavorite) => {
    // If not then add it, if it is then remove it from the list
    const list = isFavorite
      ? favoriteGenres.filter((e) => e !== genre)
      : favoriteGenres.concat(genre);
    // Persist new favorites list in db
    await Store.updateUser(uid, { favoriteGenres: list });
    // Persist new favorites list in app state
    updateUserData({ favoriteGenres: list });
  };

  return (
    <GridContainer>
      <GridItem xs={12} style={{ margin: '50px auto 0 auto' }}>
        {uid ? (
          <div style={{ padding: '0 20px' }}>
            <div
              style={{
                width: '80%',
                color: '#4557db',
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: '26px',
                lineHeight: '1.5em',
                marginBottom: '40px',
              }}
            >
              What kind of music do you listen to?
            </div>
            {Object.keys(fyndaGenres).map((e) => {
              const isFavorite = favoriteGenres.includes(e);
              return (
                <div
                  key={e}
                  style={{ float: 'left', margin: '5px' }}
                  onClick={() => toggleFavorite(e, isFavorite)}
                >
                  <Button
                    style={{
                      borderRadius: '50px',
                      backgroundColor: isFavorite ? '#171055' : '#F4F4F4',
                      border: '2px solid #E1E1E1',
                    }}
                    disableelevation='true'
                  >
                    <b style={{ color: isFavorite ? '#F4F4F4' : '#171055' }}>
                      {e}
                    </b>
                  </Button>
                </div>
              );
            })}
            <div
              style={{ clear: 'both', textAlign: 'center', marginTop: '120px' }}
            >
              <Link to={nextPage || '/allow-spotify-access'}>
                <Button
                  style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    borderRadius: '50px',
                    backgroundColor: '#aa88fc',
                  }}
                >
                  Save
                </Button>
              </Link>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </GridItem>
    </GridContainer>
  );
};

PickGenres.defaultProps = {
  favoriteGenres: [],
};

const mapStateToProps = (state) => {
  const { uid, favoriteGenres } = state.user;
  return { uid, favoriteGenres };
};

export default connect(mapStateToProps, { updateUserData })(PickGenres);
